module.exports = __webpack_public_path__ + "img/p6.e48c10d4.jpg";